import React, { useState, useEffect, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import "../../styles/AddUserModel.scss";
import profileimg from "../../images/profile-1.png";
import Multiselect from "multiselect-react-dropdown";
import { baseURL } from "../BaseUrl";
// import { travelizeAuth, salesbeeImgAuth } from "./HeaderAuthentication";
import Geocode from "react-geocode";
import { React_Google_API_Key } from "../../GoogleApiKey";
import GoogleMapAddressModel from "../GoogleMapAddressModel";
// import { LoadScript } from "@react-google-maps/api";
import Select from "react-select";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { optionsRoleListModel, optionsMapByListModel } from "../DropdownsData";
import AlertModel from "../AlertModel";
import InternetIssue from "../InternetIssue";
Geocode.setApiKey(React_Google_API_Key);

function Editusermodel(props) {
  /* HEADER AUTH START */
  let userDetails = JSON.parse(sessionStorage.getItem("usdtls"));
  const travelizeAuth = {
    "Content-Type": "application/json",
    Travelize_Authentication: userDetails,
  };
  const salesbeeImgAuth = { Travelize_Authentication: userDetails };
  /* HEADER AUTH END */

  const [fullname, setFullname] = useState("");
  const [usercode, setUserCode] = useState("");
  const [emailaddress, setEmailAddress] = useState("");
  const [mobilenum, setMobileNum] = useState("");
  const [role, setRole] = useState("");
  const [location, setLocation] = useState("");
  const [countryCode, setCountryCode] = useState("");
  const [manager, setManager] = useState("");
  const [enableStatus, setEnableStatus] = useState();
  const [country, setCountry] = useState("");
  const [shift, setShift] = useState(0);
  const [oldShift, setOldShift] = useState("");
  const [googleMapsModel, setGoogleMapsModel] = useState(false);
  const [imgFile, setImgFile] = useState("");
  const [profileImageUrl, setProfileImageUrl] = useState("");
  const [localImage, setLocalImage] = useState(null);
  const [zone, setZone] = useState([]);
  const [state, setState] = useState([]);
  const [city, setCity] = useState([]);
  const [zoneList, setZoneList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [countryCodeList, setCountryCodeList] = useState([]);

  const [managerList, setManagerList] = useState([]);
  const [zoneId, setZoneId] = useState([]);
  const [selectedOldCities, setSelectedOldCities] = useState([]);
  const [shiftList, setShiftList] = useState([]);
  const [imgFileName, setImgFileName] = useState("");
  const [zoneIds, setZoneIds] = useState([]);
  const [stateIds, setStateIds] = useState([]);
  const [cityIds, setCityIds] = useState([]);
  const [countryId, setCountryId] = useState(0);
  const [searchVal, setSearchVal] = useState("");
  const [address, setAddress] = useState("");
  const [mapById, setMapById] = useState(0);
  const [userRegionResult, setUserRegionResult] = useState({});
  const [countryList, setCountryList] = useState([]);
  const [showAlert, setShowAlert] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [alertMessage, setAlertMessage] = useState({
    alertType: "",
    message: "",
  });
  const [fieldReq, setFieldReq] = useState(false);
  const [latLan, setLatLan] = useState({
    lat: null,
    lng: null,
  });
  const [designationList, setDesignationList] = useState([]);
  const [reportDesignation, setReportDesignation] = useState(0);

  const closeAlertModel = () => {
    setShowAlert(!showAlert);
  };

  const openGoogleMaps = () => {
    setGoogleMapsModel(!googleMapsModel);
  };

  const addressFromGoogle = () => {
    openGoogleMaps();
  };

  const hiddenFileInput = useRef("");

  const handleChange = (event) => {
    const fileUploaded = event.target.files[0];
    setImgFile(fileUploaded);
    setImgFileName(event.target.files[0].name);
    const reader = new FileReader();
    reader.readAsDataURL(fileUploaded);
    reader.onloadend = () => {
      setLocalImage(reader.result);
    };
  };

  const uploadClick = () => {
    hiddenFileInput.current.click();
  };

  //* FETCH DROPDOWN DATA START *//
  useEffect(() => {
    fetchDropdownData();
  }, [zoneIds, stateIds]);

  const fetchDropdownData = () => {
    let stateResponse = userRegionResult?.allStates;
    setStateList(
      stateResponse
        ?.filter((z) => zoneIds.includes(z.zoneId))
        ?.map((item) => item) ?? []
    );
    let cityResponse = userRegionResult?.allCities;
    setCityList(
      cityResponse
        ?.filter((s) => stateIds.includes(s.stateId))
        ?.map((item) => item) ?? []
    );
  };

  useEffect(() => {
    fetchZoneStateCityselectedList();
  }, [props.userID, reportDesignation]);

  const fetchZoneStateCityselectedList = () => {
    let requestOption = {
      method: "GET",
      mode: "cors",
      headers: travelizeAuth,
    };
    fetch(`${baseURL}/api/Designation/BindDesignationDropDown`, requestOption)
      .then((res) => res.json())
      .then((res) => {
        if (res.success) {
          setDesignationList(
            res.result.map((data) => {
              return { value: data.designationID, label: data.designationName };
            })
          );
        } else {
          setDesignationList([]);
        }
      });
    fetch(
      `${baseURL}/api/User/BindTopManagerDropDown/${reportDesignation}`,
      requestOption
    )
      .then((res) => res.json())
      .then((res) => {
        if (res.success) {
          setManagerList(
            res.result.map((data) => {
              return { value: data.userId, label: data.userFullName };
            })
          );
        } else {
          setManagerList([]);
        }
      })
      .catch((error) => {
        console.log("ERROR :", error);
        setErrorMessage(error.message);
      });

    fetch(
      `${baseURL}/api/Zone/GetUserRegionsResult/?userId=${props.userID}`,
      requestOption
    )
      .then((res) => res.json())
      .then((res) => {
        let regionResult = res.result;
        setCountryList(
          regionResult?.allCountry.map((data) => {
            return { value: data.countryID, label: data.countryName };
          })
        );
        setCountryCodeList(
          regionResult?.allCountryCode.map((data) => {
            return { value: data.code, label: data.code };
          })
        );
        setShiftList(res.result.allShift);
        setZoneList(regionResult?.allZones);
        setUserRegionResult(regionResult);
        setCountryId(regionResult?.selectedCountryID[0]);
        setCountry(regionResult?.selectedCountry?.countryName);
        let zones = [
          ...new Set(regionResult.userRegions.map((z) => z.zoneName)),
        ];
        let states = [
          ...new Set(regionResult.userRegions.map((s) => s.stateName)),
        ];
        let cities = [
          ...new Set(regionResult.userRegions.map((c) => c.cityName)),
        ];
        setSelectedOldCities(cities);
        setZone(
          regionResult.allZones.filter((z) => zones.includes(z.zoneName))
        );
        setState(
          regionResult.allStates.filter((s) => states.includes(s.stateName))
        );
        setCity(
          regionResult.allCities.filter((c) => cities.includes(c.cityName))
        );
        let zonesId = [...new Set(res.result.userRegions.map((z) => z.zoneId))];

        let statesId = [
          ...new Set(regionResult.userRegions.map((s) => s.stateId)),
        ];
        let citiesId = [
          ...new Set(regionResult.userRegions.map((c) => c.cityId)),
        ];
        setZoneIds(zonesId);
        setStateIds(statesId);
        setCityIds(citiesId);
      })
      .catch((error) => {
        console.log("ERROR :", error);
        setErrorMessage(error.message);
      });
  };
  //* FETCH DROPDOWN DATA END *//

  // MULTI SELECT DROPDOWN FUNCTION START
  const handleSelectZone = (selectedList) => {
    setZone(selectedList);
    setZoneIds(selectedList.map((z) => z.zoneId));
  };
  const handleRemoveZone = (selectedList) => {
    setZone(selectedList);
    setZoneIds(selectedList.map((z) => z.zoneId));
  };
  const handleSelectState = (selectedList) => {
    setState(selectedList);
    setStateIds(selectedList.map((s) => s.stateId));
  };
  const handleRemoveState = (selectedList) => {
    setState(selectedList);
    setStateIds(selectedList.map((s) => s.stateId));
  };
  const handleSelectCity = (selectedList) => {
    setCity(selectedList);
    setCityIds(selectedList.map((s) => s.cityId));
  };
  const handleRemoveCity = (selectedList) => {
    setCity(selectedList);
    setCityIds(selectedList.map((s) => s.cityId));
  };
  // MULTI SELECT DROPDOWN FUNCTION END

  // FETCH USERDETAILS FOR EDIT START
  useEffect(() => {
    let requestOption = {
      method: "GET",
      mode: "cors",
      headers: travelizeAuth,
    };
    fetch(`${baseURL}/api/User/UserDetails/${props.userID}`, requestOption)
      .then((res) => res.json())
      .then((res) => {
        setFullname(res.result?.fullName);
        setUserCode(res.result?.code);
        setEmailAddress(res.result?.email);
        setMobileNum(res.result?.contact);
        setRole(res.result?.roleId);
        setLocation(res.result?.baseLoc?.location);
        setLatLan({
          lat: JSON.parse(res.result?.baseLoc?.latitude),
          lng: JSON.parse(res.result?.baseLoc?.longitude),
        });
        setCountryCode(res.result?.countryCode);
        setManager(res.result?.managerId);
        setEnableStatus(res.result?.enableStatus);
        setProfileImageUrl(res.result?.profilePic);
        setShift(res.result?.shiftID);
        setOldShift(res.result?.shiftID);
        setMapById(res.result?.mapType);
        setReportDesignation(res.result?.desingation?.designationID);
      })
      .catch((error) => {
        console.error("ERROR:---", error);
        setErrorMessage(error.message);
      });
  }, [props.userID]);
  // FETCH USERDETAILS FOR EDIT END

  //  ADDING ZONE STATE AND CITY BY USER START
  const addZoneStateCity = (resUserId) => {
    const zoneStateCity = city.map((item) => {
      return { ...item, userId: resUserId };
    });
    state.forEach((s_state) => {
      if (
        zoneStateCity.filter((zsc) => zsc.stateId == s_state.stateId).length ==
        0
      ) {
        zoneStateCity.push({ ...s_state, userId: resUserId });
      }
    });
    zone.forEach((z_Zone) => {
      if (
        zoneStateCity.filter((zsc) => zsc.zoneId == z_Zone.zoneId).length == 0
      ) {
        zoneStateCity.push({ ...z_Zone, userId: resUserId });
      }
    });

    let requestOption = {
      method: "POST",
      mode: "cors",
      headers: travelizeAuth,
      body: JSON.stringify(zoneStateCity),
    };
    fetch(`${baseURL}/api/Zone/AddUserRegions`, requestOption)
      .then((res) => res.json())
      .then((res) => {
        if (res.success) {
          setShowAlert(true);
          setAlertMessage({
            alertType: "success",
            message: `${res.message}`,
          });
        } else {
          setShowAlert(true);
          setAlertMessage({
            alertType: "fail",
            message: `${res.errorMessage}`,
          });
        }
      });
  };
  //  ADDING ZONE STATE AND CITY BY USER END

  //  ADDING PROFILE IMAGE BY USER START
  const editProfileImg = (e) => {
    e.preventDefault();

    if (imgFile !== null && imgFile !== "") {
      const formData = new FormData();
      formData.append("image", imgFile);
      let requestOption = {
        method: "POST",
        mode: "cors",
        headers: salesbeeImgAuth,
        body: formData,
      };
      fetch(
        `${baseURL}/api/Upload/UploadProfile?directory=Profile`,
        requestOption
      )
        .then((res) => res.json())
        .then((res) => {
          if (res.success) {
            var imgUrl = res.result[0];
            setShowAlert(true);
            setAlertMessage({
              alertType: "success",
              message: `Profile ${res.message}`,
            });
          } else {
            setShowAlert(true);
            setAlertMessage({
              alertType: "fail",
              message: `Profile ${res.errorMessage}`,
            });
            setProfileImageUrl("");
          }
          editUser(imgUrl);
        });
    } else {
      editUser();
    }
  };
  //  ADDING PROFILE IMAGE BY USER END

  // VALIDATIONS START
  const checkValidation = (e) => {
    e.preventDefault();
    const re = /^[0-9\b]+$/;
    if (e.target.value === "" || re.test(e.target.value)) {
      setMobileNum(e.target.value);
    } else {
      setShowAlert(true);
      setAlertMessage({ alertType: "fails", message: "Accept only numbers" });
    }
  };
  // VALIDATIONS END

  // MAPPING BY USER START
  const postuserMapping = () => {
    let userMapData = {
      userID: props.userID,
      mapType: JSON.parse(mapById),
    };
    let requestOption = {
      method: "POST",
      mode: "cors",
      headers: travelizeAuth,
      body: JSON.stringify(userMapData),
    };
    fetch(`${baseURL}/api/User/UpdateClientMaping`, requestOption)
      .then((res) => res.json())
      .then((res) => {
        if (res.success) {
          setTimeout(() => {
            props.showEditModel();
            props.getUserDetails();
          }, 1000);
          setShowAlert(true);
          setAlertMessage({
            alertType: "success",
            message: res.message,
          });
        } else {
          setShowAlert(true);
          setAlertMessage({
            alertType: "fails",
            message: res.errorMessage,
          });
        }
      });
  };
  // MAPPING BY USER END

  // SET EXISTING VALUE TO DROPDOWN START
  const [countryVal, setCountryVal] = useState("");
  const [designationVal, setDesignationVal] = useState("");
  const [managerVal, setManagerVal] = useState("");
  const [countryName, setCountryName] = useState("");
  const [mapByVal, setMapByVal] = useState("");

  useEffect(() => {
    if (countryCode !== null && countryCode !== "") {
      countryCodeList.map((contry) => {
        if (countryCode == contry.value) {
          setCountryVal(contry);
        }
      });
    }
    if (reportDesignation !== null && reportDesignation !== "") {
      designationList.map((designation) => {
        if (reportDesignation == designation.value) {
          setDesignationVal(designation);
        }
      });
    }
    if (manager !== null && manager !== "") {
      managerList.map((mngrlist) => {
        if (manager == mngrlist.value) {
          setManagerVal(mngrlist);
        }
      });
    }
    if (countryId !== null && countryId !== "") {
      countryList.map((cntrList) => {
        if (countryId == cntrList.value) {
          setCountryName(cntrList);
        }
      });
    }
    if (mapById !== null && mapById !== "") {
      optionsMapByListModel.map((maplist) => {
        if (mapById == maplist.value) {
          setMapByVal(maplist);
        }
      });
    }
  }, [manager, countryCode, reportDesignation, countryId, mapById]);
  // SET EXISTING VALUE TO DROPDOWN END

  // EDIT USER START
  const editUser = (imgUrl) => {
    if (
      countryCode !== "" &&
      role !== "" &&
      location !== "" &&
      country !== "" &&
      stateIds !== "" &&
      stateIds.length > 0 &&
      zoneIds !== "" &&
      zoneIds.length > 0 &&
      cityIds !== "" &&
      cityIds.length > 0
    ) {
      const editUserDetails = {
        desingation: {
          designationID: reportDesignation,
          // departmentID: departmentId,
          // role: {
          //   roleID: role,
          // },
        },
        // roleId: ,
        // registrationID: "",
        // password: "",
        userId: props.userID,
        fullName: fullname,
        email: emailaddress,
        profilePic: imgUrl,
        countryCode: countryCode,
        contact: JSON.parse(mobilenum),
        code: usercode,
        enableStatus: enableStatus,
        allowMeetings: "YES",
        managerId: manager,
        shiftID: JSON.parse(shift),
        mapType: mapById,
        baseLoc: {
          latitude: JSON.stringify(latLan.lat),
          longitude: JSON.stringify(latLan.lng),
          location: location,
        },
      };
      let requestOption = {
        method: "POST",
        mode: "cors",
        headers: travelizeAuth,
        body: JSON.stringify(editUserDetails),
      };

      // if (oldShift != shift) {
      //   // alert("Hello Shift Changed");
      //   let requestOptionShift = {
      //     method: "POST",
      //     mode: "cors",
      //     headers: travelizeAuth,
      //     body: JSON.stringify({
      //       userID: props.userID,
      //       shiftID: JSON.parse(shift),
      //     }),
      //   };
      //   fetch(`${baseURL}/api/User/UpdateShift`, requestOptionShift)
      //     .then((res) => res.json())
      //     .then((res) => {
      //       // console.log("SHIFT-CHANGE-RES::", res);
      //     });
      // }
      // let IsCityChange = false;
      //check if new city added
      // city.forEach((x) => {
      //   if (!selectedOldCities.some((y) => x.cityId == y.cityId)) {
      //     IsCityChange = true;
      //   }
      // });
      // if (!IsCityChange) {
      //   //check if city deleted
      //   selectedOldCities.forEach((x) => {
      //     if (!city.some((y) => x.cityId == y.cityId)) IsCityChange = true;
      //   });
      // }

      fetch(`${baseURL}/api/User/EditUser`, requestOption)
        .then((res) => res.json())
        .then((res) => {
          // console.log("EDIT-USER-RES::", res);
          if (res.success) {
            let resUserId = props.userID;
            // if (IsCityChange) {
            deleteOldRegion(resUserId);
            // }
            // addZoneStateCity(resUserId);
            setShowAlert(true);
            setAlertMessage({ alertType: "success", message: res.message });
          } else {
            setShowAlert(true);
            setAlertMessage({ alertType: "fails", message: res.errorMessage });
          }
          postuserMapping();
        });
    } else {
      setFieldReq(true);
      setAlertMessage({
        alertType: "fails",
        message: "Required",
      });
    }
  };
  // EDIT USER END

  // DELETE OLD REGION START
  const deleteOldRegion = (resUserId) => {
    let requestOption = {
      method: "POST",
      mode: "cors",
      headers: travelizeAuth,
    };
    fetch(
      `${baseURL}/api/Zone/DeleteUserRegions?userId=${resUserId}`,
      requestOption
    )
      .then((res) => res.json())
      .then((res) => {
        addZoneStateCity(resUserId);
      })
      .catch((error) => {
        console.log("ERROR :", error);
      });
  };
  // DELETE OLD REGION END

  // GOOGLE MAPS LOCATION START
  useEffect(() => {
    if (searchVal) {
      Geocode.fromAddress(searchVal).then(
        (response) => {
          const { lat, lng } = response.results[0].geometry.location;
          // console.log("ADDRESS-RESPONSE:::", response.results[0]);
          setLatLan({
            lat: +lat,
            lng: +lng,
          });
        },
        (error) => {
          console.error(error);
        }
      );
    }
  }, [searchVal]);

  const onMarkerDragEnd = (e) => {
    setLatLan({
      lat: +e.latLng.lat(),
      lng: +e.latLng.lng(),
    });
  };

  const searchLocation = (event) => {
    setSearchVal(event.target.value);
  };

  useEffect(() => {
    if (latLan) {
      Geocode.fromLatLng(latLan.lat, latLan.lng).then(
        (response) => {
          const address = response.results[0].formatted_address;
          // console.log("GOOGLE-ADDRESS-PLACEHOLDER:", address);
          setAddress(response.results[0].formatted_address);
          setLocation(address);
        },
        (error) => {
          console.error(error);
        }
      );
    } else {
      addressFromGoogle();
    }
  }, [latLan]);

  // GOOGLE MAPS LOCATION END

  return (
    <div>
      {errorMessage ? (
        <InternetIssue />
      ) : (
        <>
          <Modal
            show={props.editusermodelshow}
            // onHide={props.showEditModel}
            className="main_model"
          >
            <div className="add-user-heading">
              <h6 className="myinvoive-head">EDIT USER</h6>
              <i className="fa fa-times" onClick={props.showEditModel} />
            </div>
            <form onSubmit={editProfileImg}>
              <div className="container model-add-user-body">
                <div className="row add-user">
                  <div className="col-md-5">
                    <div className="img-box">
                      <div className="add_user-image">
                        {localImage ? (
                          <img
                            src={localImage}
                            alt="Uploaded Image"
                            className="add-user-image"
                          />
                        ) : (
                          <img
                            className="add-user-image"
                            src={
                              profileImageUrl !== "" &&
                                profileImageUrl !== null &&
                                profileImageUrl !== "no_img.png"
                                ? `${baseURL}/${profileImageUrl}`
                                : profileimg
                            }
                            alt="Profile Image"
                          />
                        )}
                        <button
                          type="button"
                          className="btn btn-add-user-img"
                          onClick={uploadClick}
                        >
                          <span className="btn-inline-items">
                            <i className="fa fa-user-plus"> </i>
                            <h6>Edit Profile Picture</h6>
                          </span>
                        </button>
                        <input
                          id="getFile"
                          type="file"
                          name="filetobase64"
                          accept="image/*"
                          className="btn-primary upload"
                          ref={hiddenFileInput}
                          onChange={handleChange}
                          style={{ display: "none" }}
                        />
                      </div>
                    </div>
                    <div className="img-file-name">{imgFileName}</div>
                  </div>
                  <div className="col-md-7">
                    <div className="mb-2">
                      <input
                        type="text"
                        className="form-control form add-user-input"
                        id="exampleFormControlInput1"
                        required
                        // placeholder={user.fullName}
                        value={fullname}
                        onChange={(e) => setFullname(e.target.value)}
                      />
                    </div>
                    <div className="mb-2">
                      <input
                        type="text"
                        className="form-control form add-user-input"
                        id="exampleFormControlInput1"
                        value={usercode}
                        onChange={(e) => setUserCode(e.target.value)}
                        required
                      />
                    </div>
                    <div className="mb-2">
                      <input
                        type="text"
                        className="form-control form add-user-input"
                        id="exampleFormControlInput1"
                        value={emailaddress}
                        onChange={(e) => setEmailAddress(e.target.value)}
                        required
                      />
                    </div>
                    <span className="input-mobile-field d-flex mb-2">
                      <div className="country-code">
                        <Select
                          className="react-select-container-list code-select"
                          classNamePrefix="react-select-list"
                          defaultValue={countryCodeList[null]}
                          options={countryCodeList}
                          placeholder="Code"
                          value={countryVal}
                          onInputChange={countryCodeList.label}
                          onChange={(data) => setCountryCode(data.value)}
                          isSearchable={true}
                          required
                        />
                      </div>
                      <div className="mobile-num">
                        <input
                          type="text"
                          className="form-control form add-user-input"
                          id="exampleFormControlInput1"
                          placeholder="Mobile"
                          maxLength={10}
                          value={mobilenum}
                          onChange={(e) => checkValidation(e)}
                          required
                        />
                      </div>
                    </span>
                    <div className="mb-2">
                      <Select
                        className="react-select-container-list model-select"
                        classNamePrefix="react-select-list"
                        defaultValue={designationList[null]}
                        options={designationList}
                        placeholder="Designation"
                        value={designationVal}
                        onInputChange={designationList.label}
                        onChange={(data) => setReportDesignation(data.value)}
                        isSearchable={true}
                      />

                      {(fieldReq && reportDesignation === "") ||
                        (fieldReq && reportDesignation === 0) ? (
                        <small
                          id={`Error${alertMessage.alertType}`}
                          className="form-text text-muted "
                        >
                          {alertMessage.message}
                        </small>
                      ) : (
                        ""
                      )}
                    </div>
                    {/* {role == 3 ? ( */}
                    <div className="mb-2">
                      <Select
                        className="react-select-container-list model-select"
                        classNamePrefix="react-select-list"
                        defaultValue={managerList[null]}
                        options={managerList}
                        placeholder="Select Manager"
                        value={managerVal}
                        onInputChange={managerList.label}
                        onChange={(data) => setManager(data.value)}
                        isSearchable={true}
                      />
                    </div>
                    {/* ) : (
                      ""
                    )} */}
                    <div className="mb-2 input-address-location">
                      {/* <StandaloneSearchBox> */}
                      <textarea
                        rows="3"
                        cols="20"
                        name="locationtxt"
                        wrap="hard"
                        className="form-control form add-user-input"
                        id="exampleFormControlInput1"
                        placeholder="Location"
                        value={location}
                        readOnly={true}
                      // onChange={(e) => setLocation(e.target.value)}
                      />
                      {/* </StandaloneSearchBox> */}
                      {fieldReq && location === "" ? (
                        <small
                          id={`Error${alertMessage.alertType}`}
                          className="form-text text-muted "
                        >
                          {alertMessage.message}
                        </small>
                      ) : (
                        ""
                      )}
                      <OverlayTrigger
                        placement={"right"}
                        delay={{ show: 250, hide: 300 }}
                        overlay={
                          <Tooltip id={`tooltip-googlemap`}>
                            Google Maps
                          </Tooltip>
                        }
                      >
                        <div>
                          <i
                            className="bi bi-geo-alt"
                            onClick={openGoogleMaps}
                          />
                        </div>
                      </OverlayTrigger>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6 mb-2">
                      <Select
                        className="react-select-container-list model-select"
                        classNamePrefix="react-select-list"
                        defaultValue={countryList[null]}
                        options={countryList}
                        placeholder="Select Country"
                        value={countryName}
                        onInputChange={countryList.label}
                        onChange={(data) => setCountry(data.value)}
                      // isSearchable={true}
                      />
                      {fieldReq && country === "" ? (
                        <small
                          id={`Error${alertMessage.alertType}`}
                          className="form-text text-muted "
                        >
                          {alertMessage.message}
                        </small>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="col-md-6 mb-2">
                      <Multiselect
                        className="select-add-user-model zone"
                        options={zoneList} // Options to display in the dropdown
                        selectedValues={zone} // Preselected value to persist in dropdown
                        onSelect={handleSelectZone} // Function will trigger on select event
                        onRemove={handleRemoveZone} // Function will trigger on remove event
                        showCheckbox={true}
                        displayValue="zoneName" // Property name to display in the dropdown options
                        placeholder={"Select Zone"}
                        emptyRecordMsg="No options available"
                        avoidHighlightFirstOption={true}
                        closeIcon="cancel"
                        showArrow={true}
                        selectionLimit={2}
                      />
                      {fieldReq && zoneIds.length <= 0 ? (
                        <small
                          id={`Error${alertMessage.alertType}`}
                          className="form-text text-muted "
                        >
                          {alertMessage.message}
                        </small>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  <div className="row">
                    <div className="mb-2">
                      <Multiselect
                        className="select-add-user-model"
                        options={stateList} // Options to display in the dropdown
                        selectedValues={state} // Preselected value to persist in dropdown
                        onSelect={handleSelectState} // Function will trigger on select event
                        onRemove={handleRemoveState} // Function will trigger on remove event
                        showCheckbox={true}
                        displayValue="stateName" // Property name to display in the dropdown options
                        placeholder={"Select States"}
                        emptyRecordMsg="No options available"
                        avoidHighlightFirstOption={true}
                        closeIcon="cancel"
                        groupBy="zoneName"
                        showArrow={true}
                      />
                      {fieldReq && stateIds.length <= 0 ? (
                        <small
                          id={`Error${alertMessage.alertType}`}
                          className="form-text text-muted "
                        >
                          {alertMessage.message}
                        </small>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="mb-2">
                      <Multiselect
                        className="select-add-user-model"
                        options={cityList} // Options to display in the dropdown
                        selectedValues={city} // Preselected value to persist in dropdown
                        onSelect={handleSelectCity} // Function will trigger on select event
                        onRemove={handleRemoveCity} // Function will trigger on remove event
                        showCheckbox={true}
                        displayValue="cityName" // Property name to display in the dropdown options
                        placeholder={"Select Cities"}
                        emptyRecordMsg="No options available"
                        avoidHighlightFirstOption={true}
                        closeIcon="cancel"
                        groupBy="stateName"
                        showArrow={true}
                      />
                    </div>
                  </div>
                  {/* <div className="mb-2">
                  <Form.Select
                    aria-label="Default select example"
                    name="select-shift"
                    className="form-control select-add-user-model"
                    placeholder="Select Shift"
                    value={shift}
                    onChange={(event) => setShift(event.target.value)}
                  >
                    <option className="option-label" value={0}>
                      Select Shift
                    </option>
                    {shiftList.map((data) => (
                      <option value={data.shiftID}> {data.shiftName} </option>
                    ))}
                  </Form.Select>
                </div> */}
                  <div className="mb-2">
                    <Select
                      className="react-select-container-list model-select"
                      classNamePrefix="react-select-list"
                      defaultValue={optionsMapByListModel[null]}
                      options={optionsMapByListModel}
                      placeholder="Map User By :"
                      value={mapByVal}
                      onInputChange={optionsMapByListModel.label}
                      onChange={(data) => setMapById(data.value)}
                      isSearchable={true}
                    />
                  </div>
                  <div className="mt-3">
                    <span className="enable-status d-flex">
                      <h6>Enable</h6>
                      <span className="enable-radio d-flex">
                        <div className="form-check enable-radio-status">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="flexRadioDefault"
                            id="flexRadioDefault1"
                            checked={enableStatus == 1 ? true : false}
                            onChange={() => {
                              setEnableStatus(1);
                            }}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="flexRadioDefault1"
                          >
                            Yes
                          </label>
                        </div>
                        <div className="form-check enable-radio-status">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="flexRadioDefault"
                            id="flexRadioDefault2"
                            checked={enableStatus == 0 ? true : false}
                            onChange={() => {
                              setEnableStatus(0);
                            }}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="flexRadioDefault2"
                          >
                            No
                          </label>
                        </div>
                      </span>
                    </span>
                  </div>
                </div>
              </div>
              <div className="btns-save-cancel">
                <div className="user-save-button">
                  <button
                    type="submit"
                    className="btn btn-save-up"
                  // data-bs-dismiss="modal"
                  // onClick={editProfileImg}
                  >
                    Update
                  </button>
                </div>
                <div className="user-cancel-button">
                  <button
                    onClick={props.showEditModel}
                    type="button"
                    className="btn btn-cancel"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </form>
          </Modal>
          {googleMapsModel ? (
            // <LoadScript googleMapsApiKey={React_Google_API_Key}>
            <GoogleMapAddressModel
              googleMapsModel={googleMapsModel}
              addressFromGoogle={addressFromGoogle}
              openGoogleMaps={openGoogleMaps}
              latLan={latLan}
              searchLocation={searchLocation}
              searchVal={searchVal}
              onMarkerDragEnd={onMarkerDragEnd}
              address={address}
            />
          ) : (
            // </LoadScript>
            ""
          )}
          <>
            {showAlert ? (
              <AlertModel
                showAlert={showAlert}
                alertMessage={alertMessage}
                closeAlertModel={closeAlertModel}
              />
            ) : (
              ""
            )}
          </>
        </>
      )}
    </div>
  );
}

export default Editusermodel;
